import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { authRequest, getAccessToken } from "../services/auth";

const ChangePasswordPage = ({ username, onClose }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ currentPassword: "", password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!form.currentPassword || !form.password || !form.confirmPassword) {
      setError("Current password, new password, and confirmation are required");
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await authRequest().post("/change-password", {
        oldPassword: form.currentPassword,
        newPassword: form.password,
      }, { headers: { "X-Access-Token": getAccessToken() } });
      setSuccess("Password updated successfully! Redirecting...");
      setForm({ currentPassword: "", password: "", confirmPassword: "" });
      setTimeout(() => {
        if (onClose) onClose();
        navigate("/dashboard");
      }, 1500);
    } catch (err) {
      setError(err.response?.data?.error || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minHeight="60vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Paper elevation={3} sx={{ p: 4, minWidth: 350 }}>
        <Typography variant="h6" mb={2} align="center">
          Change Password
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Current Password"
            name="currentPassword"
            type="password"
            value={form.currentPassword}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />
          <TextField
            label="Username"
            name="username"
            value={username}
            InputProps={{ readOnly: true }}
            fullWidth
            margin="normal"
          />
          <TextField
            label="New Password"
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />
          <TextField
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={form.confirmPassword}
            onChange={handleChange}
            required
            fullWidth
            margin="normal"
          />
          {error && (
            <Typography color="error" mt={1} align="center">
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="primary" mt={1} align="center">
              {success}
            </Typography>
          )}
          <Box mt={2} display="flex" gap={2}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Change Password"}
            </Button>
            <Button
              variant="outlined"
              color="inherit"
              fullWidth
              onClick={() => navigate("/dashboard")}
              disabled={loading}
            >
              Cancel
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};

export default ChangePasswordPage;
